import { AbstractControl } from "@angular/forms";

export class FormErrors {
    static getUsernameInputError(formControl: AbstractControl) {
      if (formControl.hasError('hasWhitespace')) {
        return 'Username cannot include whitespace';
      }
      if (formControl.hasError('pattern')) {
        return 'Username can only contain alphanumeric characters (no special characters or spaces)';
      }
      if (formControl.hasError('hasEmoji')) {
        return 'Username cannot include emoji.';
      }
      if (formControl.hasError('minlength')) {
        return 'Username should be at least 6 characters long';
      }
      if (formControl.hasError('maxlength')) {
        return 'Username cannot be longer than 25 characters';
      }
      return '';
    }
  
    static getPasswordInputError(formControl: AbstractControl) {
      if (formControl.hasError('minlength')) {
        return 'Password should be at least 8 characters long';
      }
      return '';
    }
  
    static getPasswordCriteriaError(formControl: AbstractControl) {
      if (
        formControl.hasError('minlength') ||
        formControl.hasError('hasWhiteSpace') ||
        formControl.hasError('hasCapitalCase') ||
        formControl.hasError('hasSmallCase') ||
        formControl.hasError('hasNumeric') ||
        formControl.hasError('hasSpecialCharacters')
      ) {
        return 'Please ensure password meets specified criteria';
      }
      return '';
    }
  
    static getPasswordMismatchError(formControl: AbstractControl) {
      if (formControl.hasError('PasswordMismatch')) {
        return 'Your password and confirmation password do not match';
      }
      return '';
    }
  
    static getLastNameInputError(formControl: AbstractControl) {
      if (formControl.hasError('maxLength')) {
        return 'Reached name length limit';
      }
      if (formControl.hasError('pattern')) {
        return 'Invalid characters';
      }
      return '';
    }
  
    static getSsnInputError(formControl: AbstractControl) {
      if (formControl.hasError('minlength')) {
        return 'Please enter the last six digits of your SSN';
      }
      return '';
    }
  
    static getDateOfBirthInputError(formControl: AbstractControl) {
      if (formControl.hasError('invalidDateOfBirthFormat')) {
        return 'Please enter a valid date';
      }
      if (formControl.hasError('invalidDateOfBirthRange')) {
        return 'Please enter a date in valid range';
      }
      return '';
    }
  
    static getContactMethodValueInputError(formControl: AbstractControl) {
      if (formControl.hasError('invalidPhoneOrEmailFormat')) {
        return 'Please enter a valid email or phone.';
      }
      return '';
    }
}